(async () => {
  const {updateURLParams, historyPush, parseHTML} = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);
  const packNames = ['Määrä', 'Quantity', 'Antal', 'Aantal'];
  const installNames = ['Asennus', 'Installation', 'Montering', 'Montage'];
  const sameOptions = (a,b) => a.length === b.length && a.every((v,i) => v === b[i]);
  customElements.define('product-variant-selector', class extends baseComponent.default {
    elements = {variantsJSON:'[data-variants-json]', optionsJSON:'[data-options-with-values]'};
    render() {
      this.cache = {};
      this.requestId = 0;
      this.isProductPage = this.hasAttribute('product-page');
      this.variantsData = JSON.parse(this.$variantsJSON.textContent);
      this.optionsData = JSON.parse(this.$optionsJSON.textContent);
      this.variant = this.variantsData.find(v => v.id === Number(this.getAttribute('current-variant-id'))) || this.variantsData[0];
      this.confirmed = this.variant;
      this.cache[this.variant.id] = this.getParentSection().outerHTML;
      this._syncInputs();
      this._checkUnavailable();
      this._summary();
      this.addEventListener('change', e => this._variantChangeHandler(e));
      this.getParentSection().addEventListener('change', e => {
        if (e.target.name === 'quantity') this._summary();
      });
      this.getParentSection().addEventListener('submit', e => {
        if (this.pending && e.target.closest('product-form')) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
      this.on('qtyStatusUpdate', (e,data) => {
        if (!this.variantsData.some(v => v.id === Number(data.variantId))) return;
        const source = data.html?.documentElement?.outerHTML || data.html?.outerHTML;
        if (typeof source === 'string' && source) this.cache[Number(data.variantId)] = source;
        if (Number(data.variantId) === this.confirmed.id) this._summary();
      }, false);
    }
    _label(name,value) {
      if (packNames.includes(name) && /^[1-9]\d*$/.test(value)) return this.dataset.packageLabel.replace('__COUNT__',value);
      if (installNames.includes(name)) {
        if (['kyllä','yes','ja'].includes(value.trim().toLowerCase())) return this.dataset.installYes;
        if (['ei','no','nej','nee'].includes(value.trim().toLowerCase())) return this.dataset.installNo;
      }
      return value;
    }
    _inputs(name) { return [...this.querySelectorAll('input[name], select[name]')].filter(el => el.name === name); }
    _syncInputs() {
      this.optionsData.forEach((option,index) => {
        this._inputs(option.name).forEach(input => {
          if (input.tagName === 'SELECT') {
            input.value = this.variant.options[index];
            [...input.options].forEach(o => { o.textContent = this._label(option.name,o.value); });
          } else {
            input.checked = input.value === this.variant.options[index];
            const label = this._label(option.name,input.value);
            input.setAttribute('aria-label',label);
            const inner = input.labels?.[0]?.querySelector('[class~="#form-swatch-inner"], [class~="#form-custom-select-item-inner"]');
            if (inner) {
              if (inner.querySelector('svg')) {
                [...inner.childNodes].filter(n => n.nodeType === 3).forEach(n => n.remove());
                inner.append(document.createTextNode(' '+label));
              } else inner.textContent = label;
            }
          }
          const picker = input.closest('product-option-picker');
          picker?.setAttribute('value',this.variant.options[index]);
          const label = this._label(option.name,this.variant.options[index]);
          picker?.querySelectorAll('[data-option-value], [data-trigger-text]').forEach(el => { el.textContent = label; });
        });
      });
    }
    _summary() {
      const box = this.querySelector('[data-choice-summary]');
      if (!box) return;
      box.hidden = false;
      box.querySelector('[data-choice-values]').textContent = this.pending ? this.dataset.loading : this.variant.options.map((value,index) => this._label(this.optionsData[index].name,value)).join(' · ');
      const total = box.querySelector('[data-choice-total]');
      const index = this.optionsData.findIndex(o => packNames.includes(o.name));
      const size = index < 0 ? '' : String(this.variant.options[index]).trim().match(/^([1-9]\d*)(?:\s*(?:kpl|pieces?|pcs?|stuk|stuks|st|stk)\.?)?$/i)?.[1] || '';
      const quantity = this.getParentSection().querySelector('product-qty select[name="quantity"]')?.value || '1';
      const known = /^[1-9]\d*$/.test(size) && /^[1-9]\d*$/.test(quantity);
      total.hidden = this.pending || !known;
      total.textContent = known ? this.dataset.packageTotal.replace('__PACKS__',quantity).replace('__SIZE__',size).replace('__TOTAL__',String(Number(size)*Number(quantity))) : '';
      const tools = this.querySelector('[data-choice-tools]');
      if (tools) {
        tools.hidden = Boolean(this.pending);
        const sku = tools.querySelector('[data-choice-sku]');
        sku.hidden = !this.variant.sku;
        sku.textContent = this.variant.sku ? `${this.dataset.skuLabel}: ${this.variant.sku}` : '';
        const link = tools.querySelector('[data-choice-contact]');
        const productURL = new URL(this.getAttribute('product-url'),window.location.origin);
        productURL.searchParams.set('variant',this.variant.id);
        link.dataset.inquiry = [this.dataset.productTitle,box.querySelector('[data-choice-values]').textContent,sku.textContent,productURL.toString()].filter(Boolean).join('\n');
        const target = new URL(link.href);
        target.hash = 'VtContactForm';
        target.searchParams.set('product_inquiry',link.dataset.inquiry);
        link.href = target.toString();
        this.dataset.selectedModel = this.variant.options[this.optionsData.findIndex(o => ['Malli','Model','Modell'].includes(o.name))] || '';
        this.dispatchEvent(new CustomEvent('vt:selection-changed',{bubbles:true}));
      }
    }
    _checkUnavailable() {
      this.optionsData.forEach((option,index) => {
        this._inputs(option.name).forEach(input => {
          const choices = [...this.variant.options]; choices[index] = input.value;
          input.toggleAttribute('data-unavailable',!this.variantsData.some(v => sameOptions(v.options,choices)));
        });
      });
    }
    _findSelection(index,value) {
      const desired = [...this.variant.options]; desired[index] = value;
      const exact = this.variantsData.find(v => sameOptions(v.options,desired));
      if (exact) return exact;
      return this.variantsData.filter(v => v.options[index] === value).map(v => ({variant:v,score:v.options.reduce((n,o,i) => n+(i!==index && o===desired[i]?1:0),0)})).sort((a,b) => b.score-a.score)[0]?.variant;
    }
    _setPending(value) {
      this.pending = value;
      this.setAttribute('aria-busy',String(value));
      const form = this.getParentSection().querySelector('product-form');
      if (value && !this.disabledButtons) {
        this.disabledButtons = [...(form?.querySelectorAll('button') || [])].map(el => [el,el.disabled]);
        this.disabledButtons.forEach(([el]) => { el.disabled = true; });
      }
      if (!value) {
        this.disabledButtons?.forEach(([el,disabled]) => { if (el.isConnected) el.disabled = disabled; });
        this.disabledButtons = null;
      }
      this._summary();
    }
    async _variantChangeHandler(e) {
      if (e.detail?.synthetic) return;
      const index = this.optionsData.findIndex(o => o.name === e.target.name);
      if (index < 0) return;
      const next = this._findSelection(index,e.target.value);
      if (!next) { this._syncInputs(); return; }
      const adjusted = next.options.some((value,i) => i !== index && value !== this.variant.options[i]);
      const requestId = ++this.requestId;
      this.controller?.abort();
      this.variant = next;
      this._syncInputs();
      this._checkUnavailable();
      const error = this.querySelector('[data-choice-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      const note = this.querySelector('[data-choice-adjusted]');
      if (note) { note.hidden = true; note.textContent = ''; }
      this._setPending(true);
      this.forwardEvent('variantLoading');
      const {queryURL,currentURL} = updateURLParams({variant:next.id},this.sectionId,window.location.origin+this.getAttribute('product-url'));
      try {
        let source = this.cache[next.id];
        if (!source) {
          const controller = new AbortController(); this.controller = controller;
          const timer = setTimeout(() => controller.abort(),15000);
          try {
            const response = await fetch(queryURL,{signal:controller.signal});
            if (!response.ok) throw new Error('Variant request failed');
            source = await response.text();
          } finally { clearTimeout(timer); }
        }
        if (requestId !== this.requestId) return;
        const html = parseHTML(source);
        const variantInput = html.querySelector('[data-variant-id-input]');
        if (Number(variantInput?.value) !== next.id || !html.querySelector('product-price')) throw new Error('Incomplete variant response');
        this.cache[next.id] = source;
        this.forwardEvent('variantChange',{html,variant:next});
        this.confirmed = next;
        if (this.isProductPage) historyPush(currentURL);
        if (note) { note.hidden = !adjusted; note.textContent = adjusted ? this.dataset.adjusted : ''; }
      } catch (_) {
        if (requestId !== this.requestId) return;
        this.variant = this.confirmed;
        this._syncInputs();
        this._checkUnavailable();
        this.forwardEvent('variantChange',{html:parseHTML(this.cache[this.confirmed.id]),variant:this.confirmed});
        if (error) { error.textContent = this.dataset.error; error.hidden = false; }
      } finally {
        if (requestId === this.requestId) this._setPending(false);
      }
    }
  });
  customElements.define('product-option-picker',class extends baseComponent.default {});
})();
